import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { Entity, Question, Section } from '../../../../interfaces/questions.interface';
import { CstQuestionnaireService } from '../../../../services/cst-questionnaire.service';
import { QuestionType } from '../../../../enums/cst-question-type.enum';
import { CommonQuestionnaireService } from '../../../../services/common-questionnaire.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CustomerQuestionnaireService } from '../../../../services/customer-questionnaire.service';
import { ConditionalLogicTargetQuestions } from '../../../../interfaces/single-selection-question.interface';

@Component({
    selector: 'app-question-header',
    templateUrl: './question-header.component.html',
    styleUrls: ['./question-header.component.scss'],
    standalone: false,
})
export class QuestionHeaderComponent implements OnChanges, OnDestroy {
    @Input() entity: Entity;
    @Input() reviewMode = false;
    @Input() index: number;
    @Output()
    questionReviewPanelOpen = new EventEmitter<boolean>();

    public localEntity: any;
    public QuestionTypes = new QuestionType();
    public reviewPanelOpen = false;

    constructor(
        public cstQuestionnaireService: CstQuestionnaireService,
        public commonQuestionnaireService: CommonQuestionnaireService,
        public customerQuestionnaireService: CustomerQuestionnaireService,
        public cdr: ChangeDetectorRef,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.entity && changes.entity.currentValue !== changes.entity.previousValue) {
            this.entity = changes.entity.currentValue;
            this.localEntity = this.cstQuestionnaireService.instanceOfQuestion(changes.entity.currentValue)
                ? (this.entity.entity as Question)
                : (this.entity.entity as Section);
            this.cdr.detectChanges();
        }
    }

    ngOnDestroy() {
        this.cdr.detach();
    }

    public toggleReviewPanel() {
        this.reviewPanelOpen = !this.reviewPanelOpen;
        this.questionReviewPanelOpen.emit(this.reviewPanelOpen);
        if (!this.reviewPanelOpen) {
            this.commonQuestionnaireService.displayOkCifc[this.index] = false;
        }
    }

    public addTagToQuestion(question: Question, tag: string) {
        for (let service of this.localEntity.service_offering) {
            if (service.name === tag) {
                service.checked = !service.checked;
            }
        }
    }

    public checkServiceOffering(question: Question, tag: string): boolean | undefined {
        if (this.localEntity) {
            for (let service of this.localEntity.service_offering) {
                if (service.name === tag) {
                    return service.checked;
                }
            }
        }

        return undefined;
    }

    public switchConditionalLogicOnQuestion($event: MatCheckboxChange, targetQuestion: Question) {
        if ($event.checked) {
            return;
        }

        this.cstQuestionnaireService.sections.forEach((section: Section) => {
            section.questions.forEach((question: Question) => {
                if (
                    this.commonQuestionnaireService.instanceOfSingleChoice(question.body.options) ||
                    this.commonQuestionnaireService.instanceOfMultipleChoice(question.body.options)
                ) {
                    question.body.options?.forEach((option) => {
                        option.target_question_list = option.target_question_list?.filter(
                            (item: ConditionalLogicTargetQuestions) => item.question_id !== targetQuestion.id,
                        );
                    });
                }
            });
        });
    }
}
